import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import "./legacy-cookie-purge";

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
